module.exports = __webpack_public_path__ + "static/White-82ea314b87f3416ccd6d61cbdc353b2b.webp";